import { render, staticRenderFns } from "./OpenWalletDrawer.vue?vue&type=template&id=2704d742&scoped=true"
import script from "./OpenWalletDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenWalletDrawer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OpenWalletDrawer.vue?vue&type=style&index=0&id=2704d742&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2704d742",
  null
  
)

export default component.exports